import React from "react"

function TimelineHeader(props) {
  return <div className="timeline-header">{props.children}</div>
}

export default TimelineHeader
